
import React from 'react'

import ContentHeaderToolbar, { ContentHeaderToolbarButton } from './ContentHeaderToolbar'
import ContentHeaderToolbarNav, { ContentHeaderNavTab } from './ContentHeaderNav'
import ContentHeaderTitle from './ContentHeaderTitle'

import './ContentHeader.scss'

interface Props {
  title: string
  subtitle?: string
  buttons?: ContentHeaderToolbarButton[]
  navTabs?: ContentHeaderNavTab[]
  className?: string
  children?: any
}

const ContentHeader = ({ title, subtitle, buttons, navTabs, className, children }: Props) => {

  return (
    <div className={`content-header ul-widget__head ${className || ''}`}>
      <ContentHeaderTitle title={title} subtitle={subtitle} />

      {buttons && buttons.length > 0 && (
        <ContentHeaderToolbar buttons={buttons} />
      )}
      {navTabs && navTabs.length > 0 && (
        <ContentHeaderToolbarNav tabs={navTabs} />
      )}

      {children}
    </div>
  )
}

export default ContentHeader
